import React, { useState } from "react";
import { css } from "emotion";

import Container from "components/shared/Container";

import styleConfig from "styles/styleConfig";
import i18n from "i18n";

const { margin, padding, colors, transition } = styleConfig;

const topNavStyle = css`
  background-color: ${colors.gray[100]};
  border-bottom: 1px solid ${colors.gray[200]};
  .container {
    display: flex;
    justify-content: flex-end;
    padding: ${padding[2]} ${padding[4]};
    .flag {
      display: flex;
      padding-left: ${padding[2]};
      color: ${colors.gray[400]};
      transition: ${transition.default};
      cursor: pointer;
      &.active {
        color: ${colors.gray[600]};
        img {
          opacity: 1;
        }
      }
      img {
        margin-right: ${margin[1]};
        opacity: 0.5;
      }
      .lang {
        line-height: 19px;
      }
      &:hover {
        color: ${colors.gray[600]};
      }
    }
  }
`;

interface Props {}

const TopNav: React.FC<Props> = () => {
  const [lang, setLang] = useState<string>(i18n.language);
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setLang(lng);
  };
  return (
    <div className={topNavStyle}>
      <Container className="container">
        <div className={`flag${lang === "be" ? " active" : ""}`} onClick={() => changeLanguage("be")}>
          <img src="./assets/lang/be.svg" alt="be" height={19} />
          <div className="lang">BE</div>
        </div>
        <div className={`flag${lang === "tr" ? " active" : ""}`} onClick={() => changeLanguage("tr")}>
          <img src="./assets/lang/tr.svg" alt="tr" height={19} />
          <div className="lang">TR</div>
        </div>
      </Container>
    </div>
  );
};

export default TopNav;
